import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFooterComponent } from "../store/slices/ui";

function useFooter(isVisible, newFooter, dependencies) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (isVisible && setFooterComponent) {
      // setFooterComponent({ Footer: newFooter });
      dispatch(setFooterComponent(newFooter));
    }
  }, [isVisible, dependencies]);

  return null;
}

export default useFooter;
